import { Hero } from "@/components/blocks/hero/Hero";
import { Features } from "@/components/blocks/features/Features";
import { SplitImage } from "@/components/blocks/split-image/SplitImage";
import { TextBlock } from "@/components/blocks/text-block/TextBlock";
import { FAQs } from "@/components/blocks/faqs/FAQs";

import { Separator } from "./blocks/separator/Separator";
import { MaskedText } from "./blocks/masked-text/MaskedText";
import { DeliveryMap } from "./blocks/delivery-map/DeliveryMap";
import { TextWithContent } from "./blocks/text-with-content/TextWithContent";
import { DeliveryLocations } from "./blocks/delivery-locations/DeliveryLocations";
import BrandSlider from "@/components/blocks/sliders/brandSlider";
import CategorySlider from "@/components/blocks/sliders/categorySlider";
import ProductSlider from "@/components/blocks/sliders/productSlider";
import SpecialSlider from "./blocks/sliders/specialSlider";
import BlogSlider from "./blocks/sliders/blogSlider";
import { PickupStores } from "./blocks/pickup-stores/PickupStores";
import PageHeading from "@/components/blocks/page-heading/PageHeading";
import HeroSlider from "@/components/sliders/HeroSlider"
import PickupMap from "@/components/leaflet/PickupMap"
import SpecialsGrid from "./blocks/specials/Grid";
import { VirtualTour } from "@/components/blocks/virtual-tour/VirtualTour";

export function PageBuilder({ content, pickupStores, shopCategories, locations, cities, stores, deliveryZips, posts, isHome = false, heroSlides }) {

  if (!Array.isArray(content)) return null;
  
  return (
    <>
      <header>
        {content
          .filter((block) => block._type === "pageHeading")
          .map((block) => (
            <PageHeading key={block._key} {...block} />
          ))}
        {content
          .filter((block) => block._type === "hero")
          .map((block) => (
            <Hero key={block._key} {...block} />
          ))}
          {isHome && <HeroSlider slides={heroSlides} />}
      </header>
      <main className="container">
        {content.map((block) => {
          if (block._type === "hero" || block._type === "pageHeading") return null; // Already rendered above

          switch (block._type) {
            case "features":
              return <Features key={block._key} {...block} />;
            case "splitImage":
              return <SplitImage key={block._key} {...block} />;
            case "textBlock":
              return <TextBlock key={block._key} {...block} />;
            case "faqs":
              return <FAQs key={block._key} {...block} />;
            case "brandSlider":
              return <BrandSlider key={block._key} {...block} />;
            case "categorySlider":
              return <CategorySlider key={block._key} shopCategories={shopCategories} {...block} />;
            case "productSlider":
              return <ProductSlider key={block._key} {...block} />;
            case "specialSlider":              
              return <SpecialSlider key={block._key} {...block} />;
            case "separator":
              return <Separator key={block._key} {...block} />;
            case "deliveryMap":
              return <DeliveryMap key={block._key} locations={locations} stores={stores} deliveryZips={deliveryZips} {...block} />;
            case "maskedText":
              return <MaskedText key={block._key} {...block} />;
            case "textWithContent":
              return <TextWithContent key={block._key} {...block} />;
            case "blogSlider":
              return <BlogSlider allPosts={posts} key={block._key} {...block} />;
            case "deliveryLocations":
              return <DeliveryLocations locations={locations} cities={cities} deliveryZips={deliveryZips} key={block._key} {...block} />
            case "pickupStores":
              return <PickupStores pickupStores={pickupStores} key={block._key} {...block} />
            case "pickupMap":
              return <PickupMap key={block._key} pickupStores={pickupStores} />;
            case "virtualTour":
              return <VirtualTour key={block._key} {...block} />;
            case "specialsGrid":
              return <SpecialsGrid key={block._key} {...block} />;
            default:
              return <div key={block._key}>Block not found: {block._type}</div>;
          }
        })}
      </main>
    </>
  );
}
